import React from "react";
import { FormControlLabel, Switch as MaterialSwitch } from "@material-ui/core";

type Props = {
  value: boolean;
  label: React.ReactNode;
  onChange: (v: boolean) => void;
  switchProps?: Partial<React.ComponentProps<typeof MaterialSwitch>>;
  formControlProps?: Partial<React.ComponentProps<typeof FormControlLabel>>;
};

const Switch: React.FC<Props> = (props) => {
  const { switchProps, formControlProps } = props;

  const style: React.CSSProperties = {};

  return (
    <FormControlLabel
      control={
        <MaterialSwitch
          checked={props.value}
          onChange={(e) => props.onChange(e.target.checked)}
          style={style}
          color="primary"
          {...switchProps}
        />
      }
      label={props.label}
      {...formControlProps}
    />
  );
};

export default Switch;
